import { render, staticRenderFns } from "./wechat-credit-pay.vue?vue&type=template&id=24e3fb03&scoped=true"
import script from "./wechat-credit-pay.vue?vue&type=script&lang=ts"
export * from "./wechat-credit-pay.vue?vue&type=script&lang=ts"
import style0 from "./wechat-credit-pay.vue?vue&type=style&index=0&id=24e3fb03&prod&lang=scss&scoped=true"
import style1 from "./wechat-credit-pay.vue?vue&type=style&index=1&id=24e3fb03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3fb03",
  null
  
)

export default component.exports